// Generic size guide data per category (inches).
export const SIZE_GUIDES = {
  tops: {
    title: "Tops & Hoodies",
    headers: ["Size", "Chest", "Waist", "Length"],
    rows: [
      ["XS", "32–34", "26–28", "26"],
      ["S", "35–37", "29–31", "27"],
      ["M", "38–40", "32–34", "28"],
      ["L", "41–43", "35–37", "29"],
      ["XL", "44–46", "38–40", "30"],
      ["XXL", "47–49", "41–43", "31"],
    ],
    note: "Measurements in inches. Garments run true to size with a fitted athletic cut. Size up for a relaxed fit.",
  },
  compression: {
    title: "Compression & Performance",
    headers: ["Size", "Bust / Chest", "Waist", "Hip"],
    rows: [
      ["XS", "30–32", "24–26", "33–35"],
      ["S", "33–35", "27–29", "36–38"],
      ["M", "36–38", "30–32", "39–41"],
      ["L", "39–41", "33–35", "42–44"],
      ["XL", "42–44", "36–38", "45–47"],
    ],
    note: "Compression fit — designed to feel snug. Refer to your true measurements; do not size up.",
  },
  accessories: {
    title: "Accessories",
    headers: ["Item", "Notes"],
    rows: [
      ["Snapback Cap", "One-size, adjustable strap (fits 21\" – 24\")"],
      ["Recovery Slides", "M (Men 7–8 / W 8–9), L (Men 9–10 / W 10–11), XL (Men 11–12)"],
      ["Training Duffel", "35L capacity · 22\" L × 11\" W × 11\" H"],
      ["Wristband", "One-size, stretch"],
    ],
    note: "Accessory sizing varies by item. Reach out if you need detailed fit info.",
  },
};

export const getSizeGuide = (category) => SIZE_GUIDES[category] || SIZE_GUIDES.tops;
